/**
 * @param name Variable name
 * @param prefix Variable prefix
 * @returns CSS Compliant variable name
 */
export const getVariableName = (name: string, prefix: string) =>
  `--${prefix}${prefix.length > 0 ? "-" : ""}${name}`;

/**
 * Map a color list to css variables.
 * @param values
 * @returns
 */
export const createCSSVariables = (values: Record<string, string>, prefix = "") =>
  // (): string =>
  Object.entries(values)
    .map(([name, value]) => `${getVariableName(name, prefix)}: ${value}`)
    .join(`;`);
